/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import {
  applyUnhideMarketOptimistic,
  isContentBlockingAffectedQuery,
  reconcileHiddenMarketResponse,
} from '../../helpers/content-blocking.js';
import type { UnhideMarketResponse, UnhideMarketVars } from '../openapi-types.gen.js';

export type { UnhideMarketResponse, UnhideMarketVars } from '../openapi-types.gen.js';

export const useUnhideMarket = createMutationHook<UnhideMarketVars, UnhideMarketResponse, unknown>({
  specName: 'useUnhideMarket',
  path: '/v1/hidden-markets/{marketPubkey}',
  method: 'DELETE',
  resolveUrl: (vars: UnhideMarketVars) => `/v1/hidden-markets/${vars.marketPubkey}`,
  
  parseResponse: (raw: unknown): UnhideMarketResponse => raw as UnhideMarketResponse,
  optimistic: [
    {
      queryKey: [],
      predicate: isContentBlockingAffectedQuery,
      reconcile: false,
      apply: (prev: unknown, vars: UnhideMarketVars, queryKey: readonly unknown[]) =>
        applyUnhideMarketOptimistic(prev, vars, queryKey),
    }, {
    queryKey: ['hidden-markets', 'detail'],
    apply: (prev: any, vars: UnhideMarketVars) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      return next;
    },
  }, {
    queryKey: ['hidden-markets', 'list'],
    apply: (prev: any, vars: UnhideMarketVars) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      return next;
    },
  }],
  viewerRelationship: {"kind":"hidden","targetArg":"marketPubkey","active":false} as const,
  onSuccess: (response: UnhideMarketResponse, vars: UnhideMarketVars, queryClient) =>
    reconcileHiddenMarketResponse(queryClient, response, vars),
});
